module.exports = __webpack_public_path__ + "static/media/25-11.61778c99.mp3";